
// LinkedIN auth
export const GETLINKEDINLOGINURL = 'auth/linkedin/geturl';
export const SIGNINURLLINKEDIN = 'auth/linkedin/signingin';

// auth
export const CHECKTOKEN = 'check-token';


// Official Topics
export const GETOFFICIALTOPICSURL='topics';


// #### TEMPLATES
// Default templates
export const GETDEFAULTTEMPLATES='default-templates';

// User Templates
export const SAVETEMPLATE='template';
export const GETUSERTEMPLATES='template';

// Calculations
export const SAVECALCULATION='calculation';
export const GETUSERCALCULATIONS='calculation';
export const DELETEUSERCALCULATION='calculation';


// Country data (API data)
export const GETCOUNTRYDATA=(country)=>`api_data/${country}/`;